import React, { useRef, useEffect } from 'react';

export const Lightbox = ({ productData, setLightbox }) => {
  const ref = useRef();

 const useOnClickOutside = (ref, handler) => {
    useEffect(() => {
      const listener = (event) => {
        if (!ref.current || ref.current.contains(event.target)) {
          return;
        }
        handler(event);
      };
      document.addEventListener('mousedown', listener);
      document.addEventListener('touchstart', listener);
      return () => {
        document.removeEventListener('mousedown', listener);
        document.removeEventListener('touchstart', listener);
      };
    }, [ref, handler]);
  };
  useOnClickOutside(ref, () => setLightbox(false));

  return (
    <div className="lightbox-overlay">
      <div className="lightbox d-flex" ref={ref}>
      <img
          className="zoomable-image  magnify-cursor lightbox-image"
          src={productData.image}
          alt=""
        />
      </div>
    </div>
  );
};
